module.exports = __webpack_public_path__ + "img/book.a2f3f5cf.svg";